import { IPageRange } from '@aon/aon-tws-common-ui';
import Axios from 'axios';
import Constants from '../constants';
import { IUserListItem } from '../models/IUserListItem';

export async function getUserCountByClientId(clientId: number, searchText: string): Promise<IUserListItem[]> {
	try {
		const res = await Axios.get(Constants.USERS_FROM_CLIENT.replace('{clientId}', clientId + '') + '?search=' + searchText, {
			headers: { Pragma: 'no-cache' },
		});
		if (res.status === 200) {
			return res.data;
		}
	} catch {
		/* generic error*/
	}
	throw new Error('An error occurred while trying to GetUserCountByClientId');
}

export async function getUsersByClientId(clientId: number, searchText: string, params: IPageRange, sort: string): Promise<IUserListItem[]> {
	try {
		const res = await Axios.get(makeQueryString(clientId, searchText, params, sort), {
			headers: { Pragma: 'no-cache' },
		});
		if (res.status === 200) {
			return res.data;
		}
	} catch {
		/* generic error*/
	}
	throw new Error('An error occurred while trying to GetUsersByClientId');
}

function makeQueryString(clientId: number, searchText: string, params: IPageRange, sort: string) {
	let query = Constants.USERS_FROM_CLIENT.replace('{clientId}', clientId + '') + '?';
	query += 'offset=' + params.offset;
	query += '&limit=' + params.limit;
	query += '&sort=' + sort;
	if (searchText !== '') {
		query += '&search=' + searchText;
	}
	return query;
}
